'use client';
import Text from "./Text.js";
export default Text;